import type { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { useI18n } from 'i18n/hooks/useI18n';
import { ListingViewSection } from 'modules/listing/components/ListingView/Section/ListingViewSection';
import { ListingRichTextTruncatedHtmlWithLinks } from 'modules/listing/components/RichText/ListingRichTextTruncatedHtmlWithLinks';

import { ListingViewDescriptionSectionImageHolder } from './ListingViewDescriptionSection.styled';

type Props = {
  listingName: string;
  image: ApiFilestackImageData | null;
  description: string;
  descriptionTruncated: string;
  showMoreLinkTitle: string;
  handleShowEmailModal?: (link: { href: string }) => void;
  onToggleDetails?: (isOpen: boolean) => void;
};

export function ListingViewDescriptionSection({
  listingName,
  image,
  description,
  descriptionTruncated,
  handleShowEmailModal,
  showMoreLinkTitle,
  onToggleDetails,
}: Props) {
  const { i18n } = useI18n();

  return (
    <ListingViewSection title={i18n('Description')}>
      {image && (
        <ListingViewDescriptionSectionImageHolder>
          <FilestackImage data={image} alt={listingName} noCrop />
        </ListingViewDescriptionSectionImageHolder>
      )}

      <ListingRichTextTruncatedHtmlWithLinks
        html={description}
        truncatedHtml={descriptionTruncated}
        showMoreLinkTitle={showMoreLinkTitle}
        showLessLinkTitle={i18n('Read less')}
        onToggle={onToggleDetails}
        onLinkClick={handleShowEmailModal}
        toggleQAId="show-listing-description-toggle"
      />
    </ListingViewSection>
  );
}
